// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.map-contents {
    position: absolute;
    left: 0;
    right: 0;
    top: calc(-1 * var(--topbar-height));
    bottom: calc(-1 * var(--bottombar-height));
}

/* Move and re-style rotation reset button */
div.ol-rotate {
    padding: 0;
    bottom: 2.75em!important;
    left: 0.5em!important;
    right: initial!important;
    top: initial!important;
}

div.ol-rotate button {
    font-size: 1.25em!important;
    background-color: var(--map-button-bg-color)!important;
    color: var(--map-button-text-color)!important;
    cursor: pointer;
}

div.ol-overlaycontainer-stopevent {
    z-index: 101!important;
}

span.map-loading-indicator {
    display: flex;
    align-items: center;
    opacity: 0;
    transition: opacity 0.5s;
    color: var(--panel-text-color);
    background-color: var(--panel-bg-color);
    box-shadow: 0 -2px 4px rgba(136, 136, 136, 0.5);
    position: absolute;
    bottom: 0.25em;
    left: 0.25em;
    padding: 0.25em;
    border-radius: 0.25em;
    font-size: small;
}

span.map-loading-indicator > div.spinner {
    width: 1.5em;
    height: 1.5em;
    margin-right: 0.25em;
}
`, "",{"version":3,"sources":["webpack://./qwc2/plugins/style/Map.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,oCAAoC;IACpC,0CAA0C;AAC9C;;AAEA,4CAA4C;AAC5C;IACI,UAAU;IACV,wBAAwB;IACxB,qBAAqB;IACrB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,sDAAsD;IACtD,6CAA6C;IAC7C,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,wBAAwB;IACxB,8BAA8B;IAC9B,uCAAuC;IACvC,+CAA+C;IAC/C,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;AACxB","sourcesContent":["div.map-contents {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: calc(-1 * var(--topbar-height));\n    bottom: calc(-1 * var(--bottombar-height));\n}\n\n/* Move and re-style rotation reset button */\ndiv.ol-rotate {\n    padding: 0;\n    bottom: 2.75em!important;\n    left: 0.5em!important;\n    right: initial!important;\n    top: initial!important;\n}\n\ndiv.ol-rotate button {\n    font-size: 1.25em!important;\n    background-color: var(--map-button-bg-color)!important;\n    color: var(--map-button-text-color)!important;\n    cursor: pointer;\n}\n\ndiv.ol-overlaycontainer-stopevent {\n    z-index: 101!important;\n}\n\nspan.map-loading-indicator {\n    display: flex;\n    align-items: center;\n    opacity: 0;\n    transition: opacity 0.5s;\n    color: var(--panel-text-color);\n    background-color: var(--panel-bg-color);\n    box-shadow: 0 -2px 4px rgba(136, 136, 136, 0.5);\n    position: absolute;\n    bottom: 0.25em;\n    left: 0.25em;\n    padding: 0.25em;\n    border-radius: 0.25em;\n    font-size: small;\n}\n\nspan.map-loading-indicator > div.spinner {\n    width: 1.5em;\n    height: 1.5em;\n    margin-right: 0.25em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
